<ng-container *transloco="let t; read: 'service-command-editor-create-async-service-request'">
  <div [formGroup]="form">
    <p-messages severity="info">
      <ng-template pTemplate>
        <p class="wrap">{{ t('description') }}</p>
      </ng-template>
    </p-messages>

    <div class="field mb-3">
      <label for="createAsyncServiceRequestWidgetId">{{ t('createAsyncServiceRequestLabel') }}</label>
      <app-create-async-service-request-autocomplete
        [formControl]="createAsyncServiceRequestWidgetId"
        [inputId]="'createAsyncServiceRequestWidgetId'"
        [placeholder]="t('createAsyncServiceRequestPlaceholder')"
      ></app-create-async-service-request-autocomplete>
      <app-form-field-help [control]="form">
        <ng-container form-field-help-hint>
          {{ t('createAsyncServiceRequestHelp', { displayName: selectedCommunicationWidget?.getDisplayName() }) }}
        </ng-container>
      </app-form-field-help>
    </div>
  </div>
</ng-container>
